module.exports = __webpack_public_path__ + "img/owl@4x.de9cd96c.png";